const tableCellAreas = {
  condition: 'Deseja realmente deletar este item?'
}

export default tableCellAreas;